<template>
  <div class="loading-dots">
    <span class="sr-only">{{ alt }}</span>
    <span class="loading__dot"></span>
    <span class="loading__dot"></span>
    <span class="loading__dot"></span>
  </div>
</template>

<script>
import "@smartdesign/core/scss/elements/loading-dot.scss";
export default {
  props: {
    /** alternative text */
    alt: {
      required: false,
      type: String,
      default: "Wird geladen",
    },
  },
};
</script>
